<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <form name="sbmnMnfst" novalidate>
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-2">
              <label class="form-label" for="sbmsnId">
                Submission Id
              </label>
            </div>
            <div class="col-sm-2">
              <!-- Textarea for edit mode -->
              @if (mode === 'edit') {
<textarea 
                
                id="efile-sub-id" 
                class="efile-form-control" 
                name="efileSubmissionId" 
                [(ngModel)]="selectedSubId" 
                cols="20" 
                [disabled]="readOnly">
              </textarea>
}
              
              <!-- Dropdown for create mode -->
              @if (mode !== 'edit') {
<select 
                
                id="elements-dropdown" 
                name="submissionId" 
                class="efile-form-control" 
                [(ngModel)]="selectedSubId"
                (ngModelChange)="showSubmissionIdRequiredError = false">
                <option [ngValue]="null">Search or enter a new value...</option>
                @for (item of submissions; track $index) {
<option [ngValue]="item">
                  {{item.SUBMISSION_ID}}
                </option>
}
              </select>
}
              
              @if (showSubmissionIdRequiredError && mode !== 'edit') {
<span class="form-error-container">
                Submission Id is required.
              </span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="summary-input">
                Element Name
              </label>
            </div>
            <div class="col-sm-2">
              <textarea 
                id="efile-summary-input" 
                class="efile-form-control" 
                name="efileElementName" 
                [(ngModel)]="elementName" 
                (ngModelChange)="showAppliedJurisRequiredError = false"
                cols="20" 
                [disabled]="mode === 'edit'">
              </textarea>
              @if (showAppliedJurisRequiredError) {
<span class="form-error-container">Element Name is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="summary-input">
                Element Value
              </label>
            </div>
            <div class="col-sm-2">
              <textarea 
                id="efile-summary-input" 
                class="efile-form-control" 
                name="efileElementValue" 
                [(ngModel)]="elementValue" 
                (ngModelChange)="showElementValueRequiredError = false"
                cols="20">
              </textarea>
              @if (showElementValueRequiredError) {
<span class="form-error-container">Element Value is required.</span>
}
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm-2">
              <label for="summary-input">
                Order Id
              </label>
            </div>
            <div class="col-sm-2">
              <textarea 
                id="summary-input" 
                class="efile-form-control" 
                name="efileOrderId" 
                [(ngModel)]="orderId" 
                (ngModelChange)="showOrderIdRequiredError = false"
                cols="20">
              </textarea>
              @if (showOrderIdRequiredError) {
<span class="form-error-container">Order Id is required.</span>
}
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    (click)="save()"
    [disabled]="!submissions || (!elementName) || isSaveClicked">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button 
    class="delete-button" 
    type="button" 
    (click)="delete()"
    [disabled]="mode === 'create' || !submissions || (!elementName) || isSaveClicked">
    @if (deleting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
  <button 
    class="cancel-button" 
    type="button" 
    (click)="cancel()">Cancel
  </button>
</div>
